module.exports = __webpack_public_path__ + "static/media/m3.9ab7a31e.png";